import { FaBoxOpen } from "react-icons/fa";
import Button from "../ui/Button";

export default function EmptyState({ title, description }) {
  return (
    <div className="rounded-xl border border-dashed border-line bg-white p-10 text-center">
      <FaBoxOpen className="mx-auto text-4xl text-primary" />
      <h3 className="mt-4 text-2xl font-semibold text-dark">{title}</h3>
      <p className="mx-auto mt-2 max-w-xl text-base leading-7 text-body">{description}</p>
      <Button to="/products" className="mt-6">Explore Products</Button>
    </div>
  );
}
